import { z } from 'zod';

import { calculateFestivalCo2DtoSchema } from '../co2/dto.type';
import { calculateFestivalEnvDtoSchema } from '../env/dto.type';
import { calculateFestivalEssDtoSchema } from '../ess/dto.type';

const projectDtoSchema = z.object({
  id: z.number(),
  results: z.object({
    co2: calculateFestivalCo2DtoSchema.optional(),
    ess: calculateFestivalEssDtoSchema.optional(),
    env: calculateFestivalEnvDtoSchema.optional(),
  }),
});

export const getAllImpactFestivalForAllProjectsDtoSchema = z.object({
  data: z.array(projectDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type AllImpactFestivalForAllProjectsDto = z.infer<
  typeof getAllImpactFestivalForAllProjectsDtoSchema
>;
